<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="required" v-if="isMandatory">*</span>
        <span class="label">行驶里程</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')" v-if="!isMandatory"></i>
      </div>
      <div class="desc">承租人超过每月限定里程后，需要支付额外使用费用。</div>
    </div>
    <RuleTip :tip="tip" />
    <div class="rule-body">
      <el-form-item :prop="`${propPrefix}.limit`" :rules="requiredRule" style="margin-bottom: 0;">
        <el-radio-group :value="modelValue.limit" @input="handleDistanceLimitChange">
          <el-radio :label="0">不限制</el-radio>
          <el-radio :label="1">限定里程</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="indent-block" v-if="modelValue.limit === 1">
        <div class="flex-row">
          <span class="label-text">每月不超过</span>
          <el-form-item :prop="`${propPrefix}.limitDistance`" :rules="modelValue.limit === 1 ? getRules(100000) : []" class="flex-input" style="margin: 0 10px; margin-bottom: 0;">
            <el-input
              :value="modelValue.limitDistance"
              placeholder="请输入"
              size="small"
              v-number:float
              @input="updateField('limitDistance', $event)"
            >
              <template slot="append">公里</template>
            </el-input>
          </el-form-item>
          <span class="label-text">超出里程按</span>
          <el-form-item :prop="`${propPrefix}.fee`" :rules="modelValue.limit === 1 ? getRules(100) : []" class="flex-input" style="margin: 0 10px; margin-bottom: 0;">
            <el-input
              :value="modelValue.fee"
              placeholder="请输入"
              size="small"
              v-number:float
              @input="updateField('fee', $event)"
            >
              <template slot="append">元/公里</template>
            </el-input>
          </el-form-item>
          <span class="label-text">缴纳费用</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getRules, requiredRule } from './utils'
import RuleTip from './RuleTip.vue'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
  isMandatory: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}

const handleDistanceLimitChange = (val) => {
  if (val === 0) {
    const newItem = { ...props.modelValue, limit: val, limitDistance: '', fee: '' }
    emit('update:modelValue', newItem)
  } else {
    updateField('limit', val)
  }
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
</style>
